import React from 'react';
import type { LinkedPatient } from '../../hooks/api/useLinkedPatients';
import { getPatientName } from '../../utils';
import { TabsContainer, Tab } from './PatientSwitcher.styled';

interface PatientSwitcherProps {
  patients: LinkedPatient[];
  selectedIndex: number;
  onPatientChange: (index: number) => void;
}

export const PatientSwitcher: React.FC<PatientSwitcherProps> = ({
  patients,
  selectedIndex,
  onPatientChange,
}) => {
  if (patients.length <= 1) return null;

  return (
    <TabsContainer>
      {patients.map((patient, index) => (
        <Tab
          key={patient.patient_id}
          $active={selectedIndex === index}
          onClick={() => onPatientChange(index)}
        >
          {getPatientName(patient.patient_display_name, patient.patient_name)}
        </Tab>
      ))}
    </TabsContainer>
  );
};
